import { inject, Service } from '@angular/core';
import { EventBusService } from '@shared';
import { filter, map, Observable, tap } from 'rxjs';
import { OrderFormInputData } from '../../models/order-form.model';
import { ORDER_FORM_EVENTS } from './order-form-events.model';

@Service({ autoProvided: false })
export class OrderFormConsumerService {
	private readonly eventBus = inject(EventBusService);

	readonly openRequest$ = this.createRequestStream(ORDER_FORM_EVENTS.OPEN);
	readonly updateRequest$ = this.createRequestStream(ORDER_FORM_EVENTS.UPDATE);

	private createRequestStream(eventName: string): Observable<OrderFormInputData> {
		return this.eventBus.on$<OrderFormInputData>(eventName).pipe(
			filter(Boolean),
			tap(wrapped => this.eventBus.clearSnapshot(eventName, wrapped.id)),
			map(wrapped => wrapped.data),
			filter(Boolean)
		);
	}
}
